export const firebaseConfig = {
    apiKey: "AIzaSyDdxZmBH5wvcVZQ70oc0y6CMRkaHxgAVBo",
    authDomain: "taptapnumber.firebaseapp.com",
    projectId: "taptapnumber",
    storageBucket: "taptapnumber.appspot.com",
    messagingSenderId: "49365674889",
    appId: "1:49365674889:web:71c220777c774b2a750f58",
    measurementId: "G-TSL90MCY9R"
  };